import React from 'react'
import EditModal from '../edit-modal'
import BusyModal from '../../modals/busy'
import useUser from '../../../hooks/use-user'

const MessageUserScreen = ({
    subject,
    targetId,
    onHide = () => {},
}) => {
    const { isBusy, user } = useUser({ id: targetId })

    if (isBusy) {
        return <BusyModal title='Retrieving user information...' />
    }

    return (
        <EditModal
            recipients={[user]}
            subject={subject}
            onHide={onHide}
        />
    )
}

export default MessageUserScreen
